// DirectionsCard — Process 2. Where new money is directed (elections) vs where
// money actually sits (actuals), plus the election rules. Built on ProcessCard.
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { formatCurrency } from '../../../utils/format';
import { ProcessCard } from '../../reusable';
import { ClockIcon, CompassIcon } from './manage-icons';
import { ElectionActualBars } from './ElectionActualBars';

export function DirectionsCard({ allocations, rules, perPaycheck, onAction, open, onToggle }) {
  const { t } = useTranslation();
  return (
    <ProcessCard
      open={open}
      onToggle={onToggle}
      className="ma-directions"
      tone="purple"
      icon={<CompassIcon />}
      title={t('manage.directions.title')}
      question={t('manage.directions.question')}
      ctaTone="blue"
      ctaLabel={t('manage.directions.cta')}
      onCta={onAction}
      summary={t('manage.directions.summary', { count: allocations.length })}
    >
      <div className="ma-dir-grid">
        <div className="ma-panel">
          <div className="ma-panel__h ma-panel__h--split">
            <span>{t('manage.directions.electionsVsActuals')}</span>
            <div className="ma-dir-legend">
              <span>
                <span className="ma-leg-dot ma-leg-dot--el" aria-hidden="true" /> {t('manage.directions.election')}
              </span>
              <span>
                <span className="ma-leg-dot ma-leg-dot--ac" aria-hidden="true" /> {t('manage.directions.actual')}
              </span>
            </div>
          </div>
          <ElectionActualBars allocations={allocations} />
          <div className="ma-dir-foot">
            <div>
              {t('manage.directions.totalElection')} <strong>100%</strong>
            </div>
            <div className="ma-dir-foot__sep" aria-hidden="true">
              ·
            </div>
            <div>
              {t('manage.directions.everyTwoWeeks', { amount: formatCurrency(perPaycheck, false) })}
            </div>
          </div>
        </div>

        <div className="ma-side-panel">
          <div className="ma-side__h">{t('manage.directions.electionRules')}</div>
          <dl className="ma-rules">
            <div>
              <dt>{t('manage.directions.minAllocation')}</dt>
              <dd>{rules.minPct}%</dd>
            </div>
            <div>
              <dt>{t('manage.directions.increment')}</dt>
              <dd>{rules.increment}%</dd>
            </div>
            <div>
              <dt>{t('manage.directions.processingTime')}</dt>
              <dd>
                <ClockIcon /> {t('manage.directions.businessDay', { count: rules.processingDays })}
              </dd>
            </div>
            <div>
              <dt>{t('manage.directions.lastChanged')}</dt>
              <dd>{rules.lastChanged}</dd>
            </div>
          </dl>
        </div>
      </div>
    </ProcessCard>
  );
}

DirectionsCard.propTypes = {
  allocations: PropTypes.array.isRequired,
  rules: PropTypes.object.isRequired,
  perPaycheck: PropTypes.number,
  onAction: PropTypes.func,
  open: PropTypes.bool,
  onToggle: PropTypes.func,
};

export default DirectionsCard;
